/**
 * The current stage of the scanning process.
 *
 * @public
 */
export enum ScanProcess {
	/**
	 * The scanner is not currently engaged.
	 */
	EMPTY = 'EMPTY',
	/**
	 * The scanner service is processing an uploaded document.
	 */
	PROCESSING = 'PROCESSING',
	/**
	 * The scanner is currently capturing a document.
	 */
	SCANNING = 'SCANNING',
}

/**
 * The current state of the scanner.
 *
 * @public
 */
export enum ScannerState {
	/**
	 * The scanner service is currently busy. It may currently be in use by
	 * another agent. If this state persists check the scanner service.
	 */
	BUSY = 'SOURCE:BUSY',
	/**
	 * The scanner service is connected and ready. You should now be able to
	 * register the scanner for this instance.
	 */
	CONNECTED = 'SOURCE:CONNECTED',
	/**
	 * The scanner service is currently disconnected.
	 */
	DISCONNECTED = 'SOURCE:DISCONNECTED',
}

/**
 * The action to instruct the scanner service to perform.
 *
 * @internal
 */
export enum ScannerAction {
	/**
	 * Instruct the scanner service to register the scanner to this instance.
	 */
	REGISTER = 'SCANNER:REGISTER',
	/**
	 * Instruct the scanner service to release the scanner from this instance.
	 */
	RELEASE = 'SCANNER:RELEASE',
}

/**
 * The error state of the scanner.
 *
 * @public
 */
export enum ScannerError {
	/**
	 * The scanner is currently locked for use by another agent.
	 */
	IS_LOCKED = 'ScannerIsLocked',
	/**
	 * The scanner is currently offline. Check the network connection between
	 * the scanner client and the service, and that the printer is powered on
	 * and connected to the host machine.
	 */
	IS_OFFLINE = 'ScannerOffline',
	/**
	 * The scanner was released by the service and is no longer available for
	 * use.
	 */
	IS_RELEASED = 'ScannerIsReleased',
}
